import gql from 'graphql-tag'

export const GET_PAYMENT_TYPE_CATEGORIES_PAGINATION_QUERY = gql`
  query GetPaymentTypeCategoriesPagination (
    $skip: Int!,
    $take: Int!,
    $orderBy: [OrderByInput!]
    $query: String
  ) {
    getPaymentTypeCategories (
      data: {
        orderBy: $orderBy
        pagination: {
          skip: $skip
          take: $take
        }
        query: $query
      }
    ) {
      hasMore
      total
      items {
        id
        title
        static
      }
    }
  }
`
